import React, {useState} from 'react';

import styles from './styles.module.css';
import chevronDown from '#/assets/icons/chevron-down-solid.svg';
import chevronUp from '#/assets/icons/chevron-up-solid.svg';

function AccordionItem({children, title, isOpened = false, hideToggle}){
    
    const [isOpen, setIsOpen] = useState(isOpened);

    const renderBasicItem = () => (
        <li className={styles.accordionItem}>
            <div className={styles.accordionHeader} onClick={()=> !isOpened && setIsOpen(!isOpen)}>
                <h3 className={styles.headerTitle}>
                    {title}
                </h3>
                {hideToggle ? <></> : <span>
                    <img src={isOpen ?  chevronUp : chevronDown} className={styles.accordionIcon} alt="icon accordion-icon"></img>
                </span>}
            </div>
            <div className={styles.accordionContent} style={{'display': isOpen ? 'block' : 'none'}} >
                {children}
            </div>
        </li>
    );

    return renderBasicItem();
} 

export default AccordionItem;